import 'NXT/styles/global.scss';

import 'NXT/index';

// @ts-ignore
if(module.hot) {
  // @ts-ignore
    module.hot.accept();
}
